export enum AhtLocationsEnum {
        ChildrenSingleQuotesHospitalDenver = 1078,
        RainbowBabies = 1079,
        NightNurse = 1080,
        AHTTest = 1082,
        AMBSTriage = 1083,
        TriageFourPediatrics = 1084,
        PediatricUrgicare = 1085,
}
